import rill from "rill";
import Contact from "../../dashboard/support/contact";

const Support = (app) => {
  app.at("/support/*", rill().setup(Contact));
};

export default Support;
